import { render, staticRenderFns } from "./ManageColumns.vue?vue&type=template&id=ca42c818&scoped=true&"
import script from "./ManageColumns.vue?vue&type=script&lang=js&"
export * from "./ManageColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca42c818",
  null
  
)

export default component.exports